import { CameraMarkerIcon } from './CameraMarkerIcon';

/**
 * author: Simran
 * id 304F1239-9ADE-4371-AFA5-AD2BC3343D24
 * name camera-marker
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-marker.svg
 * tags
 * - Photography 
 * - Navigation 
 */
export const CameraLocationIcon = CameraMarkerIcon;
export default CameraLocationIcon